import { render, staticRenderFns } from "./ListGroupItem.vue?vue&type=template&id=8376f8de&scoped=true"
import script from "./ListGroupItem.vue?vue&type=script&lang=js"
export * from "./ListGroupItem.vue?vue&type=script&lang=js"
import style0 from "./ListGroupItem.vue?vue&type=style&index=0&id=8376f8de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8376f8de",
  null
  
)

export default component.exports